import React from 'react';

import { Services } from './utils/setupServices';

// TODO make it type-safe without having to define the context in the root index
// barrel to avoid circular dependencies and without using optional chaining
// https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/context/
export const ServicesContext = React.createContext<Services>({} as Services);
